export type PlaybackDestinationKind = 'sonos' | 'local';

export interface PlaybackDestination {
  kind: PlaybackDestinationKind;
  /** Solo si kind === 'sonos' */
  coordinatorId: number | null;
}

const STORAGE_KEY = 'shc.playbackDestination.kind';

export function loadPlaybackDestinationKind(): PlaybackDestinationKind {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'local' || v === 'sonos') return v;
  } catch {
    /* ignore */
  }
  return 'sonos';
}

export function savePlaybackDestinationKind(kind: PlaybackDestinationKind): void {
  try {
    localStorage.setItem(STORAGE_KEY, kind);
  } catch {
    /* ignore */
  }
}
